var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 34.5C14.1665 18.8519 18.8518 14.1667 34.4998 14.1667H135.5C151.148 14.1667 155.833 18.8519 155.833 34.5V135.5C155.833 151.148 151.148 155.833 135.5 155.833H34.4998C18.8518 155.833 14.1665 151.148 14.1665 135.5V34.5Z",
    stroke: "#CED6E0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2083 77.9167C69.9884 77.9167 77.9167 69.9884 77.9167 60.2083C77.9167 50.4283 69.9884 42.5 60.2083 42.5C50.4283 42.5 42.5 50.4283 42.5 60.2083C42.5 69.9884 50.4283 77.9167 60.2083 77.9167Z",
    stroke: "#CED6E0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.894 89.3994L42.5 155.833H128.441C141.38 156.568 149.753 155.151 153.5 148C155.707 143.788 155.524 137.914 155.833 128.441V127.5C155.833 124.196 154.594 122.929 152.362 120.493L123.819 89.3562C118.189 83.2143 108.5 83.2341 102.894 89.3994Z",
    stroke: "#CED6E0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.0662efc9c6352a4832cadc636a150047.svg";
export { ForwardRef as ReactComponent };